import * as Yup from 'yup'


const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
const telRegExp = /^\d{2}?[-.\s]?\d{4}[-.\s]?\d{4}$/;

const usr = Yup.object({
    usuario : Yup.string(),
    password : Yup.string().required("Campo obligatorio").matches(passwordRules, 'Mayúsculas, minúsculas, números y mínimo 8 carácteres'),
    confirmacion : Yup.string().oneOf([Yup.ref('password'), null], 'No coincide' ).required("Campo obligatorio"),
    nombre : Yup.string(),
    email : Yup.string().email("Correo Electronico Invalido"),
    tel_movil : Yup.string().min(12, 'Mínimo 10 dígitos').matches(telRegExp, 'Teléfono invalido')
});
export const validacionContrato = [
    Yup.object({
        sistema : Yup.string().required(),
    }),
    Yup.object().shape({
        cliente : Yup.string().required("Campo obligatorio"),
        origen : Yup.string().required("Campo obligatorio"),
        contacto : Yup.string().required("Campo obligatorio"),
        email : Yup.string().email("Correo Electronico Invalido").required("Campo obligatorio"),
        tel_oficina: Yup.string().ensure().when("tel_movil",{
            is: val => !val || val === '',
            then: (schema) => schema.min(12, 'Mínimo 10 dígitos').matches(telRegExp, 'Teléfono invalido').required("Campo Requerido"),
            otherwise: (schema) => schema.optional()
        }),
        extension:  Yup.string().matches(/^[0-9]+$/, "Solo números"),
        tel_movil: Yup.string().ensure().when("tel_oficina",{
            is: val => !val || val === '',
            then: (schema) => schema.min(12, 'Mínimo 10 dígitos').matches(telRegExp, 'Teléfono invalido').required("Campo Requerido"),
            otherwise: (schema) => schema.optional()
        }),
    },[['tel_oficina', 'tel_movil']]),
    Yup.object({
        id_paquete : Yup.number().required("Campo obligatorio"),
        contratacion : Yup.string().required("Campo obligatorio"),
        desde : Yup.string().required("Campo obligatorio"),
        hasta : Yup.string().required("Campo obligatorio"),
        costo : Yup.number().required("Campo obligatorio"),
        estado : Yup.array().of(Yup.string().required("Campo obligatorio"))
            .min(1, "Al menos un estado"),
    }),
    Yup.object({
        usuarios : Yup.array().of(usr).min(1, "Se necesitan los datos de al menos un usuario"),
    }),
    Yup.object({
        correos : Yup.array().of(
            Yup.object({
                correo : Yup.string().email("Correo Electronico Invalido")
            })
        ),
        telefonos: Yup.array().of(
            Yup.object({
                telefono : Yup.string().min(12, 'Mínimo 10 dígitos').matches(telRegExp, 'Teléfono invalido')
            })
        )
    })
]


